import { render } from "./VtcPratiqueSeule.vue?vue&type=template&id=6b508e8e"
import script from "./VtcPratiqueSeule.vue?vue&type=script&lang=js"
export * from "./VtcPratiqueSeule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__